exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__container___1FP9B {\n  margin-top: 50px;\n  border-top: 1px solid #ffffff;\n  background-color: #eee;\n  color: #2f2f2f; }\n", ""]);

// exports
exports.locals = {
	"container": "style__container___1FP9B"
};